export default "__VITE_ASSET__BD6a0E4T__"